import { Injectable } from '@angular/core';
import { ConfirmationService } from 'primeng/api';
import { Subject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { eQMSScopeConstants } from './eqms-scope-constants';
import { ScopeOperationType } from './models/export';
import { ScopeCategoryDto } from './models/scope-category.dto';
import { NameCode } from '../shared/models/name-code';
import { CreateScopeDto } from './models/create-scope-dto';
import { AuditTrialDetails } from '../shared/models/audits/audit-trial-details';
import { BulkUserScopeSelection } from './models/bulk-user-scope-selection';
import { BulkScopeUpdateResponse } from './models/bulk-scope-updater-response';

@Injectable({
  providedIn: 'root'
})
export class EqmsScopeService {
  public isEditEQMSScopeSlider: boolean = false;
  closeAndResetEQMSScopeSlider$ = new Subject<boolean>();
  closeAndResetBulkUserScopeSlider$ = new Subject<boolean>();
  
  constructor(private confirmationService: ConfirmationService, private http: HttpClient) { }

  public openConfirmationDialog = () => {
      this.confirmationService.confirm({
        message: eQMSScopeConstants.Scope_Slider_Confirmation_Text,
        header: eQMSScopeConstants.Scope_Slider_Confirmation_Header,
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.closeAndResetEQMSScopeSlider$.next(true);
        }      
      });
    }

  public updateScope(scopeId: number, scopeData: any): Observable<any> {
    const url = eQMSScopeConstants.Scope_Update_Url.replace('{scopeId}', scopeId.toString());
    return this.http.patch(url, scopeData);
  }

  public getGlobalItaags(operationType: ScopeOperationType): Observable<NameCode[]> {
    const url = eQMSScopeConstants.Global_Itaags_Api.replace('{operationType}', operationType.toString());
    return this.http.get<NameCode[]>(url);
  }

  public getScopeCategories(): Observable<ScopeCategoryDto[]> {
    return this.http.get<ScopeCategoryDto[]>(eQMSScopeConstants.Scope_Categories_Api);
  }

  public createScope(scopeData: CreateScopeDto): Observable<any> {
    return this.http.post(eQMSScopeConstants.Scope_Create_Url, scopeData);
  }

  public updateBulkUserScopeUsers(scopeData: BulkUserScopeSelection): Observable<BulkScopeUpdateResponse> {
    return this.http.post<BulkScopeUpdateResponse>(eQMSScopeConstants.Scope_Bulk_User_Update_Url, scopeData);
  }

  public getAvailableParentScopes(): Observable<NameCode[]> {
    return this.http.get<NameCode[]>(eQMSScopeConstants.Get_Parent_Scope_Url);
  }

  public getScopeAuditTrail(scopeId: number): Observable<AuditTrialDetails[]> {
    const url = `${eQMSScopeConstants.Scope_Audit_Trail_Url}?scopeId=${scopeId}`;
    return this.http.get<AuditTrialDetails[]>(url);
  }

      public openConfirmationDialogForBulkUserSlider = () => {
      this.confirmationService.confirm({
        message: eQMSScopeConstants.Scope_Slider_Confirmation_Text,
        header: eQMSScopeConstants.Scope_Slider_Confirmation_Header,
        icon: 'pi pi-exclamation-triangle',
        acceptIcon: 'pi pi-check',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.closeAndResetBulkUserScopeSlider$.next(true);
        }      
      });
    }
  
}
